import { Shape }          from '@tokamap/core';
import React              from 'react';
import ListContext        from '@widesk-ui/contexts/ListContext';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';

type ShapeFilterOfRow = (model: any) => ((shape: Shape) => boolean) | undefined;

export const ShapeHoverFilter = React.createContext<ShapeFilterOfRow>(() => undefined);

const setHoveredShapes = (ids: string[]) => currentEditorStore.get?.mapAdapter.setHoveredShapes(ids);

const ShapeHoverRow = (props: { id: string; children: React.ReactNode }) => {
	const { listStore } = React.useContext(ListContext);
	const filterOfRow = React.useContext(ShapeHoverFilter);

	const hoverShapes = () => {
		const model = listStore?.data.find((m: any) => m.id?.toString() === props.id);
		const filter = model && filterOfRow(model);

		setHoveredShapes(filter ? currentEditorStore.allShapes.filter(filter).map(shape => shape.id) : []);
	};

	React.useEffect(() => () => setHoveredShapes([]), []);

	return (
		<div onMouseEnter={hoverShapes} onMouseLeave={() => setHoveredShapes([])}>
			{props.children}
		</div>
	);
};

export default ShapeHoverRow;
